export class Modal {
    static init(): void {
        const modals = document.querySelectorAll('[data-modal]') as NodeListOf<HTMLElement>;

        document.addEventListener('click', (e) => {
            const target = e.target as HTMLElement;

            if (target.hasAttribute('data-modal-close')) {
                const modal = target.closest('[data-modal]') as HTMLElement | null;
                if (modal) {
                    Modal.close(modal);
                }
            }
        });
    }

    static open(modal: HTMLElement): void {
        modal.classList.add('is-open');
    }

    static close(modal: HTMLElement): void {
        modal.classList.remove('is-open');
    }
}
